import {ParsedUrlQuery} from 'querystring'
import {Pages, PageKey} from 'lib/constants'

/**
 * Replace query params with the props given. Attach extra params to the end.
 * Ex:
 * toHref('analysis', {regionId: 123, projectId: 456}) // => /regions/123/analysis?projectId=456
 */
export function pageToHref(key: PageKey, props?: ParsedUrlQuery): string {
  const result = routeTo(key, props)
  return result?.as ?? ''
}

export function routeTo(key: PageKey, props?: ParsedUrlQuery) {
  const page = Pages[key]
  if (!page) {
    console.error(`${key} is not a valid page!`)
    return null
  }
  const as = replaceProps(page, props)
  return {as, href: page}
}

function replaceProps(str: string, obj?: ParsedUrlQuery) {
  if (!obj) return str
  const searchParams = new URLSearchParams()
  for (const key in obj) {
    const value = obj[key]
    // Skip null values or accidental stringified null values
    if (value == null) continue
    if (
      typeof value === 'string' &&
      (value === 'null' || value === 'undefined')
    )
      continue

    const pathKey = `[${key}]`
    if (str.includes(pathKey)) {
      if (Array.isArray(value)) {
        str = str.replace(pathKey, value[0])
        for (const v of value.slice(1)) {
          searchParams.append(key, v)
        }
      } else {
        str = str.replace(pathKey, value)
      }
    } else {
      if (Array.isArray(value)) {
        for (const v of value) {
          searchParams.append(key, v)
        }
      } else {
        searchParams.append(key, value)
      }
    }
  }
  const searchParamsStr = searchParams.toString()
  if (searchParamsStr.length > 0) str += `?${searchParamsStr}`
  return str
}
